// サンドラッグ版チラシ一括登録
import axios from 'axios';
import googleAnalyticsClient from '../common/google_analytics/ajax_handling';
import karteErrorClient from '../common/karte/error';
import karteCustonEventClient from '../common/karte/custom_event';

document.addEventListener('DOMContentLoaded', () => {
  const newDiv = document.getElementById('leaflets_bulk_new');
  if (newDiv == null) {
    return;
  }

  const uploadArea = document.getElementById('upload_files_area');
  const requireBrandSelect = document.getElementById('require_brand_select');
  const brandSelect = document.getElementById('brand_id');
  const uploadStatus = document.getElementById('files_uploading_status');
  const uploadCompleted = document.getElementById('files_upload_completed');
  const uploadFailed = document.getElementById('files_upload_failed');
  const filesUploadFailedDetails = document.getElementById('files_upload_failed_details');
  const uploadCancel = document.getElementById('files_uploading_status_cancel');
  const failedFilesDetailsFileNamesUl = document.getElementById('failed_files_details_file_names');
  const downloadFailedFiles = document.getElementById('download_failed_files');
  const uploadingStatusBar = document.getElementById('uploading_status_bar');
  const parallelProcessingNum = 5;
  const registrationOrderTimestamp = Date.now(); // 読み込んだ時のタイムスタンプ

  (newDiv as HTMLElement).addEventListener('drop', (event) => {
    event.preventDefault();
  });

  (newDiv as HTMLElement).addEventListener('dragover', (event) => {
    event.preventDefault();
    (event.dataTransfer as DataTransfer).dropEffect = 'copy';
  });

  (uploadArea as HTMLElement).addEventListener('drop', (event) => {
    event.preventDefault();
    removeClassDropping();
    const files = (event.dataTransfer as DataTransfer).files;
    const filesCount = files.length as number;
    if (checkUploading()) {
      alert('アップロード中です');
    } else if (filesCount && confirm(filesCount + '件のファイルをアップロードしますか？')) {
      uploadFilesInParallel(files);
    }
  });

  (uploadArea as HTMLElement).addEventListener('dragover', (event) => {
    event.preventDefault();
    (event.dataTransfer as DataTransfer).dropEffect = 'copy';
    addClassDropping();
  });

  (uploadArea as HTMLElement).addEventListener('dragleave', (event) => {
    event.preventDefault();
    removeClassDropping();
  });

  const addClassDropping = () => {
    (uploadArea as HTMLElement).classList.add('dropping');
  }

  const removeClassDropping = () => {
    (uploadArea as HTMLElement).classList.remove('dropping');
  }

  (requireBrandSelect as HTMLElement).addEventListener('drop', (event) => {
    event.preventDefault();
    alert('ブランドを指定してください');
  });

  (requireBrandSelect as HTMLElement).addEventListener('dragover', (event) => {
    event.preventDefault();
    (event.dataTransfer as DataTransfer).dropEffect = 'copy';
  });

  type resultLeaflet = { result: boolean };

  const uploadFilesInParallel = (files: FileList) => {
    // 初期化
    showUploadStatus();
    removeCanceledClassFromUploadArea();
    hideUploadFailed();
    hideUploadCompleted();
    hideFailedFilesDetails();
    refreshFailedFileNames();
    removeFailedFileNames();
    removeDownloadFailedFiles();
    setFileNamesToStorage(files);
    initializeUpdateStatusBar();

    // KARTEに登録イベントを送信
    sendKarteEvent(
      'create_content',
      'leaflets',
      'チラシを一括登録で登録しました'
    );

    // 並列処理
    const fileNames = getFileNames(files);
    const filesCount = files.length as number;
    var uploadedFiles = new Array;
    const per = Math.ceil(filesCount/parallelProcessingNum);
    const sortedUploadFiles = sortUploadFiles(files) as Array<File>;
    var passFlag = false; // アップロードを通すフラグ
    for (var i=0; i<filesCount; i++){
      const breakFlag = ((i+1)%per === 0);
      const lastFileFlag = filesCount === (i+1);
      const file = sortedUploadFiles[i];
      (file as any).fileIndex = i;
      uploadedFiles.push(file);
      if (breakFlag || (!breakFlag && lastFileFlag) || passFlag) {
        const skipFlag = passFlag = detectSkipFlag((file as File).name);
        if (lastFileFlag || !skipFlag) {
          const dt = new DataTransfer();
          [].forEach.call(uploadedFiles, file => {
            dt.items.add(file);
          });
          if (0 < dt.files.length) {
            uploadFiles(dt.files, fileNames);
          }
          // 初期化
          uploadedFiles = new Array;
          // 通すかどうかのフラグをfalseにする
          passFlag = false;
        }
      }
    }
  }

  const uploadFiles = (files: FileList, allFileNames: Array<string>) => {
    var currentFileCount = 0;
    uploadCurrentFileName(files[currentFileCount]); // 最初のファイル名を描画
    uploadFilesCount(allFileNames); // 最初の進捗を描画
    uploadFile(files, currentFileCount, allFileNames);
  }

  const sortUploadFiles = (files: FileList) => {
    var filesArray = new Array;
    [].forEach.call(files, file => {
      filesArray.push(file);
    });
    filesArray = filesArray.sort((file1: File, file2: File) => {
      if (file1.name < file2.name) {
        return -1;
      }
      if (file1.name > file2.name) {
        return 1;
      }
      return 0;
    });
    return filesArray;
  }

  const detectSkipFlag = (fileName: string) => {
    // 表のファイルかどうか
    return fileName.indexOf('_01.') != -1;
  }

  const uploadFile = (files: FileList, currentFileCount: number, allFileNames: Array<string>) => {
    if (checkUploadCancel()) {
      return; // cancledクラスを持っていればキャンセルする
    }
    const file = files[currentFileCount];
    const formData = new FormData();
    const brandId = (brandSelect as HTMLSelectElement).value;
    const filesCount = files.length;
    const fileIndex = (file as any).fileIndex;
    // 順番は逆数にする (10桁まで)
    const reciprocalNumber = Math.round(1/(fileIndex+1) * 10**10) / 10**10
    const registrationOrder = registrationOrderTimestamp + '-' + reciprocalNumber;
    formData.append('file', file);
    formData.append('brand_id', brandId);
    formData.append('registration_order', registrationOrder);
    const token = (document.getElementsByName('csrf-token')[0] as HTMLElement).getAttribute('content');
    axios
      .post<resultLeaflet>('/staff/api/leaflets/bulk_create_each_one', formData, {
        headers: {
          'content-type': 'multipart/form-data',
          'X-CSRF-Token': token
        }
      })
      .then(response => {
        const data = response.data;
        if (data['result']) {
          // アップロード成功
          successFileUpload(file);
        } else {
          // アップロード失敗
          failFileUpload(file)
          addFailedFileName(file, allFileNames);
        }
        currentFileCount += 1;
        updateStatusBar(allFileNames);
        uploadFilesCount(allFileNames);
        // 次の処理 or 処理完了
        if (currentFileCount != filesCount) {
          uploadCurrentFileName(files[currentFileCount]);
          uploadFile(files, currentFileCount, allFileNames);
        } else {
          showUploadFinished(allFileNames);
        }
      }).catch(error => {
        // サンドラッグ版チラシ一括登録のチラシアップロード処理でエラー発生
        const errorPath = '/staff/api/leaflets/bulk_create_each_one';
        const errorMessage = 'サンドラッグ版チラシ一括登録のチラシアップロード処理でエラー発生';
        const el = document.querySelector<HTMLElement>('#staff_infomation');
        const staffId = el?.dataset.staffId;
        const now = el?.dataset.now;

        // エラーイベントを送信 (GA)
        if(staffId && now) {
          googleAnalyticsClient.error({
            time: now,
            path: errorPath,
            staffId: staffId,
            message: errorMessage
          });
        }

        // エラーイベントを送信 (KARTE)
        karteErrorClient.error({
          path: errorPath,
          message: errorMessage
        });

        if (!hasRetryCancelFlag() && confirm('ネットワークエラーが発生しました。リトライしますか？')) {
          uploadFile(files, currentFileCount, allFileNames);
        } else {
          // アップロード失敗を処理する
          addRetryCancelFlag();
          for (var i=currentFileCount; i<filesCount; i++){
            failFileUpload(files[currentFileCount])
            addFailedFileName(files[currentFileCount], allFileNames);
            currentFileCount += 1;
            if ((i+1) == filesCount) {
              showUploadFinished(allFileNames);
            }
          }
        }
      });
  }

  const addRetryCancelFlag = () => {
    (uploadStatus as HTMLElement).classList.add('retry-canceled');
  }

  const removeRetryCancelFlag = () => {
    (uploadStatus as HTMLElement).classList.remove('retry-canceled');
  }

  const hasRetryCancelFlag = () => {
    return (uploadStatus as HTMLElement).classList.contains('retry-canceled');
  }

  const setFileNamesToStorage = (files: FileList) => {
    [].forEach.call(files, file => {
      localStorage.setItem(generateFileKey((file as File).name), 'yet'); // データセット
    });
  }

  const generateFileKey = (fileName: string) => {
    return ('leafletBulkNew-' + fileName);
  }

  const getFileNames = (files: FileList) => {
    var names = new Array;
    [].forEach.call(files, file => {
      names.push((file as File).name);
    });
    return names;
  }

  const successFileUpload = (file: File) => {
    localStorage.setItem(generateFileKey(file.name), 'true'); // 成功
  }

  const failFileUpload = (file: File) => {
    localStorage.setItem(generateFileKey(file.name), 'false'); // 成功
  }

  const getSucceededFileCount = (allFileNames: Array<string>) => {
    var files = new Array;
    [].forEach.call(allFileNames, fileName => {
      const key = generateFileKey(fileName)
      if (localStorage.getItem(key) == 'true') {
        files.push(fileName);
      }
    });
    return files.length;
  };

  const getFaiedFileCount = (allFileNames: Array<string>) => {
    var files = new Array;
    [].forEach.call(allFileNames, fileName => {
      const key = generateFileKey(fileName)
      if (localStorage.getItem(key) == 'false') {
        files.push(fileName);
      }
    });
    return files.length;
  };

  const getYetFileCount = (allFileNames: Array<string>) => {
    var files = new Array;
    [].forEach.call(allFileNames, fileName => {
      const key = generateFileKey(fileName);
      if (localStorage.getItem(key) == 'yet') {
        files.push(fileName);
      }
    });
    return files.length;
  };

  const showUploadStatus = () => {
    (uploadStatus as HTMLElement).style.display = 'block';
  }

  const hideUploadStatus = () => {
    (uploadStatus as HTMLElement).style.display = 'none';
  }

  const uploadCurrentFileName = (file: File) => {
    const currentUploadFileName = document.getElementById('current_upload_file_name');
    (currentUploadFileName as HTMLElement).innerText = file.name + ' をアップロード中...';
  }

  const uploadFilesCount = (allFileNames: Array<string>) => {
    const filesCount = allFileNames.length;
    const currentFileCount = filesCount - getYetFileCount(allFileNames);
    const filesUploadingCount = document.getElementById('files_uploading_count');
    (filesUploadingCount as HTMLElement).innerText = '(' + currentFileCount + ' / ' + filesCount + 'ファイル)';
  }

  const updateStatusBar = (allFileNames: Array<string>) => {
    const filesCount = allFileNames.length;
    const currentFileCount = filesCount - getYetFileCount(allFileNames);
    (uploadingStatusBar as HTMLElement).style.width = ((currentFileCount/filesCount) * 100) + '%';
    if (currentFileCount == filesCount) {
      (uploadingStatusBar as HTMLElement).classList.add('completed');
    }
  }

  const initializeUpdateStatusBar = () => {
    (uploadingStatusBar as HTMLElement).style.width = '0';
  }

  const showUploadFinished = (allFileNames: Array<string>) => {
    const succeededFileCount = getSucceededFileCount(allFileNames);
    const faiedFileCount = getFaiedFileCount(allFileNames);
    if (getYetFileCount(allFileNames) != 0) {
      // 処理が完了していない
      return;
    }
    removeRetryCancelFlag();
    if (0 < faiedFileCount) {
      // エラーあり
      const filesUploadFailedMessage = document.getElementById('files_upload_failed_message');
      (filesUploadFailedMessage as HTMLElement).innerText = faiedFileCount + '件のファイルのアップロードに失敗しました';
      setTimeout(() => {
        hideUploadStatus();
        showUploadFailed();
      }, 3000);
    } else {
      // アップロード完了
      const filesUploadCompletedMessage = document.getElementById('files_upload_completed_message');
      (filesUploadCompletedMessage as HTMLElement).innerText = succeededFileCount + '件のファイルをアップロードしました';
      setTimeout(() => {
        hideUploadStatus();
        showUploadCompleted();
      }, 3000);
    }
  }

  (brandSelect as HTMLSelectElement).addEventListener('change', () => {
    refresh();
  });

  const checkBrandSelect = () => {
    if ((brandSelect as HTMLSelectElement).value) {
      (uploadArea as HTMLElement).style.display = 'block';
      (requireBrandSelect as HTMLElement).style.display = 'none';
    } else {
      (uploadArea as HTMLElement).style.display = 'none';
      (requireBrandSelect as HTMLElement).style.display = 'block';
    }
  }

  const refreshFailedFileNames = () => {
    const lis = (failedFilesDetailsFileNamesUl as HTMLElement).children;
    [].forEach.call(lis, li => {
      (li as HTMLElement).remove();
    });
  }

  const removeFailedFileNames = () => {
    (failedFilesDetailsFileNamesUl as HTMLElement).innerHTML = '';
  }

  const addFailedFileName = (file: File, allFileNames: Array<string>) => {
    const failedFilesDetailsTitle = document.getElementById('failed_files_details_title');
    const li = document.createElement('li');
    const nameDiv = document.createElement('div');
    const sizeDiv = document.createElement('div');
    const faiedFileCount = getFaiedFileCount(allFileNames);
    nameDiv.classList.add('file-name');
    sizeDiv.classList.add('file-size');
    nameDiv.innerText = file.name;
    sizeDiv.innerText = bytesToSize(file.size);
    li.appendChild(nameDiv);
    li.appendChild(sizeDiv);
    (failedFilesDetailsFileNamesUl as HTMLElement).appendChild(li);
    (failedFilesDetailsTitle as HTMLElement).innerText = 'エラーファイル一覧' + ' (' + faiedFileCount + '件)';
    (downloadFailedFiles as HTMLElement).dataset.failedFiles += file.name + "\n";
  }

  const bytesToSize = (bytes: any) => {
    if      (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
    else if (bytes >= 1048576)    { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
    else if (bytes >= 1024)       { bytes = (bytes / 1024).toFixed(2) + " KB"; }
    else if (bytes > 1)           { bytes = bytes + " bytes"; }
    else if (bytes == 1)          { bytes = bytes + " byte"; }
    else                          { bytes = "0 bytes"; }
    return bytes;
  }

  (filesUploadFailedDetails as HTMLElement).addEventListener('click', () => {
    showFailedFilesDetails();
    hideUploadFailed();
  });

  // const reloadWithBrand = () => {
  //   const brandId = (brandSelect as HTMLSelectElement).value;
  //   if (brandId) {
  //     var path = location.pathname;
  //     location.href = path + '?brand_id=' + brandId;
  //   }
  // }

  const cancelUpload = () => {
    addCanceledClassToUploadArea();
    hideUploadStatus();
  }

  (uploadCancel as HTMLElement).addEventListener('click', () => {
    if (confirm('本当にキャンセルしますか？')) {
      cancelUpload();
    }
  });

  (downloadFailedFiles as HTMLElement).addEventListener('click', () => {
    var text = ((downloadFailedFiles as HTMLElement).dataset.failedFiles as string);
    downloadAsTextFile('エラーファイル一覧.txt', text);
  });

  const addCanceledClassToUploadArea = () => {
    (uploadArea as HTMLElement).classList.add('canceled');
  }

  const removeCanceledClassFromUploadArea = () => {
    (uploadArea as HTMLElement).classList.remove('canceled');
  }

  const checkUploadCancel = () => {
    return (uploadArea as HTMLElement).classList.contains('canceled');
  }

  window.addEventListener('beforeunload', event => {
    if (checkUploading()) {
      event.preventDefault();
      event.returnValue = 'データ送信中です。\n本当に離脱しますか？';
    }
  });

  const checkUploading = () => {
    return (uploadStatus as HTMLElement).style.display == 'block';
  }

  const showUploadCompleted = () => {
    (uploadCompleted as HTMLElement).style.display = 'flex';
  }

  const hideUploadCompleted = () => {
    (uploadCompleted as HTMLElement).style.display = 'none';
  }

  const showUploadFailed = () => {
    (uploadFailed as HTMLElement).style.display = 'flex';
  }

  const hideUploadFailed = () => {
    (uploadFailed as HTMLElement).style.display = 'none';
  }

  const showFailedFilesDetails = () => {
    const failedFilesDetails = document.getElementById('failed_files_details');
    (failedFilesDetails as HTMLElement).style.display = 'block';
  }

  const hideFailedFilesDetails = () => {
    const failedFilesDetails = document.getElementById('failed_files_details');
    (failedFilesDetails as HTMLElement).style.display = 'none';
  }

  const removeDownloadFailedFiles = () => {
    (downloadFailedFiles as HTMLElement).dataset.failedFiles = '';
  }

  const downloadAsTextFile = (fileName: string, content: string) => {
    const blobText = new Blob([ content ], { 'type': 'text/plain' });
    const canUseSaveBlob = window.navigator.msSaveBlob !== undefined;
    if ( canUseSaveBlob ) {
      window.navigator.msSaveBlob(blobText, fileName);
      return;
    }

    const tempAnchor = document.createElement( 'a' );
    tempAnchor.href = URL.createObjectURL(blobText);
    tempAnchor.setAttribute('download', fileName);

    tempAnchor.dispatchEvent( new MouseEvent( 'click' ) );
  };

  const sendKarteEvent = (event_name: string, content_name: string, message: string) => {
    // 投稿したことをKARTEに通知
    karteCustonEventClient.sendEvent({
      event_name: event_name,
      content_name: content_name,
      message: message
    });
  }

  const refresh = () => {
    checkBrandSelect();
  }

  const initialize = () => {
    refresh();
  }

  initialize();
});
